import React from 'react';
import TeacherNavBar from "../../components/teacher-nav-bar/teacher-nav-bar";
import Page from "../../components/page/page";

const TeacherPage = () => {
    return (
        <Page isModal={false}>
            <TeacherNavBar/>
        </Page>
    );
};

export default TeacherPage;
